module.exports = __webpack_public_path__ + "static/media/arrow-forward.b0055372.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-forward.svg
// module id = 150
// module chunks = 0